import { Box, Typography } from "@mui/material";
import { IconCheck, IconX } from "@tabler/icons-react";
import { map, some } from "lodash";

import Imposto from "../../../models/imposto";
import TabelaBase from "./tabelaBase";

type Props = {
  impostos: Imposto[] | undefined;
};

export default function TabelaArgumentos({ impostos }: Props) {
  const header: {
    titulo: string;
    key: string;
    ordem: number;
    align: "left" | "center" | "right";
  }[] = [
    { titulo: "Detalhe", key: "detalhe", ordem: 1, align: "left" },
    { titulo: "", key: "presente", ordem: 2, align: "center" },
  ];

  const detalhes = [
    "Cliente operou fora da isenção dos R$20.000 para Ações.",
    "Cliente teve resultados com Day Trade.",
    "Cliente teve resultados com Fundos Imobiliários.",
    "Cliente teve DARFs com impostos devidos.",
    "Cliente pôde compensar prejuízos acumulados.",
  ];

  const rows = map(detalhes, (detalhe, index) => ({
    detalhe: celulaDetalhe(detalhe),
    presente: celulaPresente(index),
  }));

  return <TabelaBase header={header} rows={rows} />;

  function celulaDetalhe(detalhe: string): JSX.Element {
    return celulaTexto(detalhe);
  }

  function celulaPresente(index: number): JSX.Element {
    switch (index) {
      case 0:
        return some(
          impostos,
          (imposto) =>
            !!imposto.resultado &&
            imposto.resultado.operacoesComuns.valorVendidoIsentavel > 20000
        ) ? (
          marcaSim()
        ) : (
          marcaNao()
        );
      case 1:
        return some(
          impostos,
          (imposto) => imposto.resultado?.operacoesDaytrade.resultadoTotal != 0
        ) ? (
          marcaSim()
        ) : (
          marcaNao()
        );
      case 2:
        return some(
          impostos,
          (imposto) => imposto.resultado?.operacoesFii.resultadoTotal != 0
        ) ? (
          marcaSim()
        ) : (
          marcaNao()
        );
      case 3:
        return some(
          impostos,
          (imposto) => !!imposto.darf && imposto.darf?.impostoDevido > 0
        ) ? (
          marcaSim()
        ) : (
          marcaNao()
        );
      case 4:
        return some(
          impostos,
          (imposto) => imposto.abatimentos.prejuizo != 0
        ) ? (
          marcaSim()
        ) : (
          marcaNao()
        );
      default:
        return <></>;
    }
  }

  function celulaTexto(texto?: string): JSX.Element {
    return <Typography>{texto}</Typography>;
  }

  function marcaSim(): JSX.Element {
    return (
      <Box
        component="span"
        sx={{ display: "inline-flex", color: "success.main" }}
      >
        <IconCheck size={18} />
      </Box>
    );
  }

  function marcaNao(): JSX.Element {
    return (
      <Box
        component="span"
        sx={{ display: "inline-flex", color: "text.secondary" }}
      >
        <IconX size={18} />
      </Box>
    );
  }
}
